<template>
  <div class="page-content">
    <div class="content">
      <div class="search">
        <el-form :inline="true" :model="filters" :size="size" @keyup.enter.native="handleQuery" @submit.native.prevent>
          <el-form-item>
            <el-select v-model="filters.companyList" filterable placeholder="客户" clearable>
              <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filters.status" filterable placeholder="计划状态">
              <el-option label="全部状态" :value="-1"></el-option>
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="filters.time"
              type="month"
              value-format="yyyy/MM/dd"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button :size="size" type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content">
        <el-table :data="tableData" style="width: 100%" height="680"
          header-cell-class-name='table-header-cell' cell-class-name='table-cell'
          border stripe fit  highlight-current-row
          v-loading='loading'
          >
          <el-table-column prop="name" label="计划名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="clientCompanyName" label="客户" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="type" label="类型" min-width="100" :formatter="handleTypeFormat" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" min-width="100" :formatter="handleStatusFormat" show-overflow-tooltip></el-table-column>
          <el-table-column prop="creatorNickname" label="创建人" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="time" label="计划起止时间" min-width="260" show-overflow-tooltip>
            <template slot-scope="scope">
              {{$moment(scope.row.startTime).format('YYYY/MM/DD')}}~{{$moment(scope.row.endTime).format('YYYY/MM/DD')}}
            </template>
          </el-table-column>
          <el-table-column prop="projectProcess" label="计划进度" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="describe" label="描述" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="220" align="center">
            <template slot-scope="scope">
              <!-- 详情 -->
              <el-button @click.native.prevent="handleDetail(scope.$index, scope.row)" type="text" :size="size" >详情</el-button>
              <!-- 修改 -->
              <!-- <el-button v-if="scope.row.status === 1" @click.native.prevent="handleEdit(scope.$index, scope.row)" type="text" :size="size" >修改</el-button> -->
              <!-- 生成工单 -->
              <el-button v-if="scope.row.status === 1" @click.native.prevent="handleOrderDispatch(scope.$index, scope.row)" type="text" :size="size" >生成工单</el-button>
              <!-- 重新生成工单 -->
              <!-- <el-button @click.native.prevent="handleOrderDispatch(scope.$index, scope.row)" type="text" :size="size" >重新生成工单</el-button> -->
              <!-- 终止计划 -->
              <!-- <el-button v-if="scope.row.status === 1" @click.native.prevent="handleTermination(scope.$index, scope.row)" type="text" :size="size" >终止</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
          :current-page="currentPage"
          :page-sizes="[15, 30, 60, 100]"
          :page-size="limit"
          :page-count="pageCount"
          layout="sizes, prev, pager, next, jumper"
          >
        </el-pagination>
      </div>
    </div>
    <!-- 新建计划 -->
    <!-- <plan-add-or-update ref="planAddOrUpdate" v-if="planAddOrUpdateVisible" @handleQuery='handleQuery'></plan-add-or-update> -->
    <!-- 修改计划 -->
    <!-- <plan-edit ref="planEdit" v-if="planEditVisible" @handleQuery='handleQuery'></plan-edit> -->
    <!-- 详情 -->
    <detail-drawer ref="detailDrawer" :statusList='statusList' :typeList='typeList' v-if="detailDrawerVisible" ></detail-drawer>
    <!-- 生成工单 -->
    <order-create-dialog ref="orderDialog" v-if="orderDialogVisible" dialogTitle='生成工单' :typeList='typeList' @handleQuery='handleQuery' />
    <!-- 重新生成工单 -->
    <!-- <order-dispatch-dialog ref="orderRedispatch" v-if="orderRedispatchVisible" dialogTitle="重新派单" :isRedispatch='true' @handleQuery='handleQuery'></order-dispatch-dialog> -->
  </div>
</template>

<script>
import planEdit from './planEdit.vue'
import planAddOrUpdate from './planAddOrUpdate.vue'
import detailDrawer from './detailDrawer.vue'
import orderCreateDialog from './orderCreateDialog.vue'
export default {
  name: 'workPlan',
  components: {
    planAddOrUpdate,
    detailDrawer,
    orderCreateDialog,
    planEdit
  },
  data () {
    return {
      loading: false,
      planAddOrUpdateVisible: false,
      detailDrawerVisible: false,
      orderDialogVisible: false,
      orderRedispatchVisible: false,
      planEditVisible: false,
      typeList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 },
        { label: "带电检测", value: 6 },
        { label: "电能安装", value: 7 }
      ],
      statusList: [
        { label: '计划中', value: 1 },
        { label: '已过期', value: 2 },
        { label: '已取消', value: 3 },
        { label: '执行中', value: 4 },
        { label: '已完成', value: 5 }
      ],
      size: 'small',
      filters: {
        name: '',
        companyList: '',
        time: new Date(),
        status: -1
      },
      tableData: [
      ],
      currentPage: 1,
      limit: 15,
      pageCount: 1,
      companyList: []
    }
  },
  created () {
    Promise.all([
      this.handleGetCompany()
    ]).then(() => {
      this.handleQuery()
    })
  },
  methods: {
    handleTypeFormat (row, column, cellValue, index) {
      let val = ''
      this.typeList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleStatusFormat (row, column, cellValue, index) {
      let val = ''
      this.statusList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleGetCompany () {
      this.$api.electricOperations.listClientsForElectricOperationsCompany(0, '', '').then((res) => {
        if (res.success) {
          this.companyList = res.data
        }
      })
    },
    handleQuery () {
      this.loading = true
      this.tableData = []
      console.log(this.filters.time)
      let startTime = this.filters.time !== null ? this.$moment(this.filters.time).startOf('month').format('YYYY/MM/DD HH:mm:ss') : ''
      let endTime = this.filters.time !== null ? this.$moment(this.filters.time).endOf('month').format('YYYY/MM/DD HH:mm:ss') : ''
      const client = this.filters.companyList === '' ? [] : [this.filters.companyList]
      this.$api.electricOperations.listElectricOperationsPlansInPage(
        0, 
        client,
        startTime,
        endTime,
        this.filters.status,
        this.currentPage,
        this.limit
        ).then((res) => {
        this.loading = false
        if (res.success) {
          this.tableData = res.data.listData
          this.currentPage = res.data.currentPage
          this.pageCount = res.data.totalPage
          console.log(this.total)
        }
      })
    },
    pageSizeChangeHandle (val) {
      console.log(val)
      this.limit = val
      this.handleQuery()
    },
    pageCurrentChangeHandle (val) {
      console.log(val)
      this.currentPage = val
      this.handleQuery()
    },
    currentPage () {},
    handleAdd () {
      this.planAddOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.planAddOrUpdate.init(null)
      })
    },
    handleEdit (index, row) {
      this.planEditVisible = true
      this.$nextTick(() => {
        this.$refs.planEdit.init(row)
      })
    },
    handleDetail (index, row) {
      this.detailDrawerVisible = true
      this.$nextTick(() => {
        this.$refs.detailDrawer.init(row)
      })
    },
    handleOrderDispatch (index, row) {
      this.orderDialogVisible = true
      this.$nextTick(() => {
        this.$refs.orderDialog.init(row)
      })
    },
    handleOrderRedispatch (index, row) {
      this.orderRedispatchVisible = true
      this.$nextTick(() => {
        this.$refs.orderRedispatch.init(row)
      })
    },
    handleTermination (index, row) {
      this.$confirm('确认要终止吗？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        this.$api.electricOperations.cancelElectricOperationsPlan(row.id).then(res => {
          if (res.success) {
            this.$message.success("终止成功")
            this.handleQuery()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.table-content {
  .table-header-cell{
    background:rgba(220,225,230,1);
    color: #333;
    text-align: center;
  }
}
</style>

<style lang="scss" scoped>

.page-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  overflow: auto;
  .search {
    text-align: left;
  }
}

.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
